import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit } from '@angular/core';
import { ItemsService } from 'src/app/services/items.service';
import { MultiItemGroupSelect } from '../../../common/models/multiItemSelect';
import { FacilityManager } from 'src/app/managers/facility.manager';
import { FacilityItemInformation } from 'src/app/common/models/facilityItemInformation';
import { ItemGroup } from 'src/app/common/models/itemGroup';
import { AdminUIHelpers } from 'src/app/common/helpers';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

import { PrepMinutesFormatPipe, LeadMinutesFormatPipe } from '@pipes/minutes-hours-pipe';

@Component({
  selector: 'multi-item-checklist',
  templateUrl: './multi-item-checklist.component.html',
  styleUrls: ['./multi-item-checklist.component.scss'],
  standalone: true,
  imports: [MatCheckbox, FormsModule, PrepMinutesFormatPipe, LeadMinutesFormatPipe],
})
export class MultiItemChecklist implements OnInit, AfterViewInit {
  @Input() public item!: ItemGroup;
  @Input() public relatedItems: MultiItemGroupSelect[] = [];
  @Input() public allItems: FacilityItemInformation[] = [];
  @Output() public relatedItemsChange = new EventEmitter<MultiItemGroupSelect[]>();
  @Output() public validationCheck = new EventEmitter();
  public selectAll = false;
  public itemsSelected = 1;
  public dataLoaded = false;

  constructor(
    private itemsService: ItemsService,
    private _facilityManager: FacilityManager,
  ) {}

  public ngOnInit(): void {
    if (this.relatedItems.length < 1) {
      if (this.allItems.length > 0) {
        this.initializeRelatedItems(
          this.allItems.filter((x) => x.departmentName === this.item.items[0].departmentName),
        );
      } else {
        this.itemsService
          .getMenuItemsForDepartment(this._facilityManager.getCurrentFacility(), this.item.items[0].departmentName)
          .subscribe({
            next: (items) => {
              this.initializeRelatedItems(items);
            },
          });
      }
    } else {
      this.dataLoaded = true;
    }
  }

  private initializeRelatedItems(items: FacilityItemInformation[]): void {
    const nonCommodityItems = items.filter(
      (i) => i.commodityGroupId === 0 || i.commodityGroupId === null || i.commodityGroupId === undefined,
    );
    const menuItemGroups = AdminUIHelpers.mapItemsToMenuItemGroup(nonCommodityItems);
    const filteredItemGroups = AdminUIHelpers.mapItemGroupsToItemGroupsArray(menuItemGroups);
    this.relatedItems = filteredItemGroups.map((item) => {
      const relatedItem: MultiItemGroupSelect = item;
      relatedItem.isSelected = item.itemNumber === this.item.itemNumber;
      return relatedItem;
    });
    this.refreshItemsSelected();
    this.dataLoaded = true;
  }

  public ngAfterViewInit(): void {
    /**Need a timeout here to give the multi item component
     * time to finish loading before we can scroll */
    setTimeout(() => this.attemptScroll(), 450);
  }

  private attemptScroll(): void {
    // poll async until element is available to scroll to
    if (this.dataLoaded) {
      document.getElementById(this.item.itemNumber)!.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else {
      setTimeout(() => this.attemptScroll(), 100);
    }
  }

  public refreshItemsSelected(): void {
    this.relatedItemsChange.emit(this.relatedItems);
    this.validationCheck.emit();
    this.itemsSelected = this.relatedItems.filter((f) => {
      return f.isSelected === true;
    }).length;
  }

  public selectAllItems(): void {
    this.relatedItems.forEach((ri) => {
      if (ri.itemNumber !== this.item.itemNumber) {
        ri.isSelected = this.selectAll;
      }
    });
    this.refreshItemsSelected();
  }
}
